var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "educa_manage_wrap"
    },
    [
      _c("div", { staticClass: "educa_manage_header" }, [
        _c("h2", [_vm._v("学生管理")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "operation" },
          [
            _c(
              "el-select",
              {
                attrs: { placeholder: "请选择一级组织", clearable: "" },
                on: { change: _vm.changeStructId },
                model: {
                  value: _vm.tableIpt.structId,
                  callback: function($$v) {
                    _vm.$set(_vm.tableIpt, "structId", $$v)
                  },
                  expression: "tableIpt.structId"
                }
              },
              _vm._l(_vm.organizeList, function(item) {
                return _c("el-option", {
                  key: item.structId,
                  attrs: { label: item.structName, value: item.structId }
                })
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "el-select",
              {
                attrs: { placeholder: "请选择行政班", clearable: "" },
                on: { change: _vm.teachingClassChange },
                model: {
                  value: _vm.teachingClassId,
                  callback: function($$v) {
                    _vm.teachingClassId = $$v
                  },
                  expression: "teachingClassId"
                }
              },
              _vm._l(_vm.teachingClassList, function(item, key) {
                return _c("el-option", {
                  key: key,
                  attrs: { label: item.className, value: item.id }
                })
              }),
              1
            ),
            _vm._v(" "),
            _c("n-search-input", {
              staticStyle: { "margin-right": "10px" },
              attrs: { placeholder: "请输入账号/姓名/学号/手机号" },
              on: {
                searchInput: function($event) {
                  return _vm.searchList()
                }
              },
              model: {
                value: _vm.tableIpt.mobile,
                callback: function($$v) {
                  _vm.$set(_vm.tableIpt, "mobile", $$v)
                },
                expression: "tableIpt.mobile"
              }
            }),
            _vm._v(" "),
            _vm.$_has("zledu.jiaoxue.student.save")
              ? _c(
                  "el-button",
                  {
                    attrs: { plain: "" },
                    on: {
                      click: function($event) {
                        return _vm.addStudent()
                      }
                    }
                  },
                  [_vm._v("添加学生")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$_has("zledu.jiaoxue.student.import")
              ? _c(
                  "el-button",
                  {
                    attrs: { plain: "" },
                    on: {
                      click: function($event) {
                        return _vm.uploadStudent()
                      }
                    }
                  },
                  [_vm._v("导 入")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$_has("zledu.jiaoxue.student.export")
              ? _c(
                  "el-button",
                  {
                    attrs: { plain: "", disabled: _vm.isCanExport },
                    on: {
                      click: function($event) {
                        return _vm.exportStudent()
                      }
                    }
                  },
                  [_vm._v("导 出")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$_has("zledu.jiaoxue.student.delete")
              ? _c(
                  "el-button",
                  {
                    attrs: { plain: "" },
                    on: {
                      click: function($event) {
                        return _vm.deleteStudent()
                      }
                    }
                  },
                  [_vm._v("批量删除")]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "educa_manage_table",
          style: "padding-bottom:" + (_vm.tableData.length ? "0" : "16") + "px"
        },
        [
          _c("n-table", {
            ref: "student_manage",
            attrs: {
              tableData: _vm.tableData,
              tableHeader: _vm.StudentTableHeader,
              ISChangeCheckout: true,
              TableHeight: _vm.TableHeight
            },
            on: { operation: _vm.operation }
          }),
          _vm._v(" "),
          _vm.tableData.length
            ? _c("el-pagination", {
                staticClass: "paginator",
                attrs: {
                  "current-page": _vm.pageTotal.currentPage,
                  background: "",
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.pageTotal.pageSize,
                  "pager-count": 5,
                  layout: "sizes, prev, pager, next",
                  total: _vm.pageTotal.total
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                  "update:currentPage": function($event) {
                    return _vm.$set(_vm.pageTotal, "currentPage", $event)
                  },
                  "update:current-page": function($event) {
                    return _vm.$set(_vm.pageTotal, "currentPage", $event)
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.addStudentDialogVisible,
            "close-on-press-escape": false,
            "close-on-click-modal": false,
            width: "600px",
            "before-close": _vm.handleClose,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addStudentDialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "training-site" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "80px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "whole_line",
                      attrs: { label: "姓名", prop: "name" }
                    },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "20", placeholder: "请输入姓名" },
                        model: {
                          value: _vm.ruleForm.name,
                          callback: function($$v) {
                            _vm.$set(_vm.ruleForm, "name", $$v)
                          },
                          expression: "ruleForm.name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "whole_line",
                      attrs: { label: "学号", prop: "studentNumber" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "20",
                          placeholder: "请输入学号",
                          disabled:
                            this.ruleForm.userId && this.ruleForm.userId != ""
                              ? true
                              : false
                        },
                        model: {
                          value: _vm.ruleForm.studentNumber,
                          callback: function($$v) {
                            _vm.$set(_vm.ruleForm, "studentNumber", $$v)
                          },
                          expression: "ruleForm.studentNumber"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form_cont" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "证件类型", prop: "cardType" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择证件类型" },
                              model: {
                                value: _vm.ruleForm.cardType,
                                callback: function($$v) {
                                  _vm.$set(_vm.ruleForm, "cardType", $$v)
                                },
                                expression: "ruleForm.cardType"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "身份证", value: "0" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "其他", value: "1" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.ruleForm.cardType == 0
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "证件号", prop: "idCard" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: "18",
                                  placeholder: "请输入证件号"
                                },
                                model: {
                                  value: _vm.ruleForm.idCard,
                                  callback: function($$v) {
                                    _vm.$set(_vm.ruleForm, "idCard", $$v)
                                  },
                                  expression: "ruleForm.idCard"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.ruleForm.cardType == 1
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "证件号", prop: "other" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: "30",
                                  placeholder: "请输入证件号"
                                },
                                model: {
                                  value: _vm.ruleForm.other,
                                  callback: function($$v) {
                                    _vm.$set(_vm.ruleForm, "other", $$v)
                                  },
                                  expression: "ruleForm.other"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "性别", prop: "sex" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择性别" },
                              model: {
                                value: _vm.ruleForm.sex,
                                callback: function($$v) {
                                  _vm.$set(_vm.ruleForm, "sex", $$v)
                                },
                                expression: "ruleForm.sex"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "男", value: "0" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "女", value: "1" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "省份", prop: "province" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择省份" },
                              model: {
                                value: _vm.ruleForm.province,
                                callback: function($$v) {
                                  _vm.$set(_vm.ruleForm, "province", $$v)
                                },
                                expression: "ruleForm.province"
                              }
                            },
                            _vm._l(_vm.provinceList, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.cityName,
                                  value: item.cityName
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "一级组织", prop: "firstStructId" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              on: { change: _vm.changeFirstStructId },
                              model: {
                                value: _vm.ruleForm.firstStructId,
                                callback: function($$v) {
                                  _vm.$set(_vm.ruleForm, "firstStructId", $$v)
                                },
                                expression: "ruleForm.firstStructId"
                              }
                            },
                            _vm._l(_vm.organizeList, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.structName,
                                  value: item.structId
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "城市", prop: "city" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "20",
                              placeholder: "请输入城市"
                            },
                            model: {
                              value: _vm.ruleForm.city,
                              callback: function($$v) {
                                _vm.$set(_vm.ruleForm, "city", $$v)
                              },
                              expression: "ruleForm.city"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "二级组织", prop: "secondStructId" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择", clearable: "" },
                              on: { change: _vm.changeSecondStructId },
                              model: {
                                value: _vm.ruleForm.secondStructId,
                                callback: function($$v) {
                                  _vm.$set(_vm.ruleForm, "secondStructId", $$v)
                                },
                                expression: "ruleForm.secondStructId"
                              }
                            },
                            _vm._l(_vm.secondOrganizeList, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.structName,
                                  value: item.structId
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "教育层次", prop: "educationalLevel" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择教育层次" },
                              model: {
                                value: _vm.ruleForm.educationalLevel,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.ruleForm,
                                    "educationalLevel",
                                    $$v
                                  )
                                },
                                expression: "ruleForm.educationalLevel"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "高职", value: "高职" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "中职", value: "中职" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "本科", value: "本科" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "班级", prop: "teachingClassId" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              on: { change: _vm.changeClass },
                              model: {
                                value: _vm.ruleForm.teachingClassId,
                                callback: function($$v) {
                                  _vm.$set(_vm.ruleForm, "teachingClassId", $$v)
                                },
                                expression: "ruleForm.teachingClassId"
                              }
                            },
                            _vm._l(_vm.teacherClassList, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.className, value: item.id }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "入学年份", prop: "schoolDate" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              "value-format": "yyyy",
                              type: "year",
                              placeholder: "请选择入学年份"
                            },
                            model: {
                              value: _vm.ruleForm.schoolDate,
                              callback: function($$v) {
                                _vm.$set(_vm.ruleForm, "schoolDate", $$v)
                              },
                              expression: "ruleForm.schoolDate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.handleSubmit("ruleForm")
                    }
                  }
                },
                [_vm._v("保 存")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "导入学生名单",
            visible: _vm.centerDialogVisible,
            "close-on-press-escape": false,
            "close-on-click-modal": false,
            width: "600px",
            "before-close": _vm.handleCloseUpload,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.centerDialogVisible = $event
            }
          }
        },
        [
          _vm.fail * 1 > 0
            ? _c("p", { staticClass: "failMsg" }, [
                _vm._v(
                  "导入成功" +
                    _vm._s(_vm.success) +
                    "条，失败" +
                    _vm._s(_vm.fail) +
                    "条\n\t\t\t\t"
                ),
                _c(
                  "a",
                  {
                    attrs: { target: "view_frame" },
                    on: {
                      click: function($event) {
                        return _vm.jumpFail()
                      }
                    }
                  },
                  [_vm._v("下载查看错误模板信息")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.uploading,
                  expression: "uploading"
                }
              ],
              staticClass: "training-site upload-content",
              attrs: { "element-loading-text": "学生名单导入中" }
            },
            [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.fileName,
                      callback: function($$v) {
                        _vm.fileName = $$v
                      },
                      expression: "fileName"
                    }
                  }),
                  _vm._v(" "),
                  _vm.fileName
                    ? _c(
                        "span",
                        {
                          staticClass: "on",
                          on: {
                            click: function($event) {
                              return _vm.delFile()
                            }
                          }
                        },
                        [_vm._v("删除")]
                      )
                    : _c("span", { staticClass: "off" }, [_vm._v("删除")]),
                  _vm._v(" "),
                  _c("p", [_c("i", [_vm._v("*")]), _vm._v("注意：")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("1.请使用模板文件导入\n\t\t\t\t\t\t"),
                    _c(
                      "a",
                      {
                        attrs: { target: "view_frame" },
                        on: {
                          click: function($event) {
                            return _vm.jump()
                          }
                        }
                      },
                      [_vm._v("下载模板")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("2.请先在组织管理中创建班级后再导入学生！")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "right" },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      staticClass: "upload-demo",
                      attrs: {
                        action: "https://jsonplaceholder.typicode.com/posts/",
                        "before-upload": _vm.beforeUpload,
                        "show-file-list": false,
                        limit: 1,
                        "on-exceed": _vm.handleExceed,
                        "file-list": _vm.fileList
                      }
                    },
                    [
                      _c("img", {
                        attrs: { src: "/static/images/wenjianjia.png", alt: "" }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("选择文件")])
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.uploading },
                  on: {
                    click: function($event) {
                      return _vm.handleTrainingeSites(false)
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.uploading },
                  on: {
                    click: function($event) {
                      return _vm.handleTrainingeSites(true)
                    }
                  }
                },
                [_vm._v("保 存")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5087d262", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5087d262","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/new_educa_module/educa/studentManage/studentAdmin.vue
// module id = null
// module chunks = 